export default __webpack_public_path__ + "static/media/welcome-fintro.edb77ae2.svg";